// API client -------------------------------------------------------------- //

export class HTTPError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'HTTPError';
    this.details = details;
  }
}

export class APIError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'APIError';
    this.details = details;
  }
}

export class APIClientError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'APIClientError';
    this.details = details;
  }
}

// notifications ----------------------------------------------------------- //

export class NotificationError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'NotificationError';
    this.details = details;
  }
}

// branding ---------------------------------------------------------------- //

export class BrandingError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'BrandingError';
    this.details = details;
  }
}

// validation -------------------------------------------------------------- //

export class ValidatorError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'ValidatorError';
    this.details = details;
  }
}

export class ValidationError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = 'ValidationError';
    this.details = details;
  }
}
